import React from "react";
import { Row, TimePicker } from "antd";

const TmsTimepicker = ({ label, value, setValue, mandatory }) => {
  const format = "HH:mm"; // 24-hour format

  return (
    <Row style={{ width: "100%", padding: "20px 0px 10px 0px" }}>
      {label}
      {mandatory && <span className="mandatory">*</span>}

      <TimePicker
        style={{ width: "100%", marginTop: "5px" }}
        format={format}
        value={value} // Convert value to moment object
        placeholder="Select Time"
        onChange={(data) => {
          setValue(data); // Convert value to Date object
        }}
      />
    </Row>
  );
};

export default TmsTimepicker;
